/**
 * Diretiva v-permission para controle de exibição baseado em permissões
 *
 * Uso:
 * v-permission="'manage_users'" - Verifica uma permissão específica
 * v-permission="['manage_users', 'view_reports']" - Verifica qualquer uma das permissões (OR)
 * v-permission:all="['manage_users', 'view_reports']" - Verifica todas as permissões (AND)
 * v-permission:role="1" - Verifica se tem um perfil específico
 * v-permission:roles="[1, 2]" - Verifica se tem qualquer um dos perfis
 * v-permission:system-admin - Verifica se é administrador geral do sistema
 */

import {
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
  hasRole,
  hasAnyRole,
  isSystemAdministrator,
} from "@/utils/permissions";

export default {
  install(Vue) {
    Vue.directive("permission", {
      inserted(el, binding) {
        const { value, arg } = binding;
        let hasAccess = false;

        // v-permission:system-admin
        if (arg === "system-admin") {
          hasAccess = isSystemAdministrator();
        }
        // v-permission:role="1"
        else if (arg === "role") {
          hasAccess = hasRole(value);
        }
        // v-permission:roles="[1, 2]"
        else if (arg === "roles") {
          hasAccess = hasAnyRole(value);
        }
        // v-permission:all="['permission1', 'permission2']"
        else if (arg === "all") {
          hasAccess = hasAllPermissions(Array.isArray(value) ? value : [value]);
        }
        // v-permission="'permission'" ou v-permission="['permission1', 'permission2']"
        else {
          if (Array.isArray(value)) {
            hasAccess = hasAnyPermission(value);
          } else {
            hasAccess = hasPermission(value);
          }
        }

        // Remove o elemento se não tiver acesso
        if (!hasAccess) {
          el.parentNode && el.parentNode.removeChild(el);
        }
      },

      // Atualiza quando o valor muda
      update(el, binding) {
        const { value, arg } = binding;
        let hasAccess = false;

        if (arg === "system-admin") {
          hasAccess = isSystemAdministrator();
        } else if (arg === "role") {
          hasAccess = hasRole(value);
        } else if (arg === "roles") {
          hasAccess = hasAnyRole(value);
        } else if (arg === "all") {
          hasAccess = hasAllPermissions(Array.isArray(value) ? value : [value]);
        } else {
          if (Array.isArray(value)) {
            hasAccess = hasAnyPermission(value);
          } else {
            hasAccess = hasPermission(value);
          }
        }

        // Controla visibilidade
        if (hasAccess) {
          el.style.display = "";
        } else {
          el.style.display = "none";
        }
      },
    });
  },
};
